<template>
  <el-tabs class="channel-menu" v-model="activeName">
    <el-tab-pane
      v-for="channel in filteredChannels"
      :key="channel"
      :label="$t(channels[channel])"
      class="preview"
      :name="channel"
    >
      <div class="full-size">
        <component
          :is="previewComponents[channel] || null"
          :key="deviceKey"
          :model="model"
          :variant-key="variantKey"
          :workflow-email="workflowEmail"
          :profile-id="profileId"
          :custom-attributes="customAttributes"
          :language="getLanguage"
        />
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import PreviewContentEmail from '@/modules/campaign-manage/components/preview/PreviewContentEmail.vue'
import { channelLabels } from '@/modules/campaign-manage/enum/Labels'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'

export default {
  name: 'PreviewContent',
  components: {
    PreviewContentEmail
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    variantKey: {
      type: String,
      required: true
    },
    workflowEmail: {
      type: Object,
      required: false
    },
    customAttributes: {
      type: Object,
      required: false
    },
    language: {
      type: String,
      required: false
    },
    profileId: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      activeName: 'email',
      supportedChannels: ['email'],
      channelLabels,
      deviceKey: 0
    }
  },
  computed: {
    previewComponents() {
      return {
        email: PreviewContentEmail
      }
    },
    filteredChannels() {
      return this.selectedChannels.filter(channel =>
        this.supportedChannels.includes(channel)
      )
    },
    channels() {
      return {
        ...this.channelLabels,
        inapp: 'CampaignForm_ChannelsSelect_Inapp'
      }
    },
    selectedChannels() {
      if (this.model.type === campaignTypeEnum.TYPE_WORKFLOW) {
        return ['email']
      }

      let result = Object.keys(this.channels).filter(
        channel => this.model[channel] === 1
      )

      return [...new Set(result)]
    },

    getLanguage() {
      return this.model.languages_multi ? this.language : ''
    }
  },

  methods: {
    reloadData() {
      this.deviceKey++
    }
  },
  watch: {
    variantKey: {
      immediate: true,
      handler() {
        this.reloadData()
      }
    },
    language: {
      immediate: true,
      handler() {
        this.reloadData()
      }
    },
    customAttributes: {
      immediate: true,
      handler() {
        this.reloadData()
      },
      deep: true
    },
    profileId: {
      immediate: true,
      handler() {
        this.reloadData()
      }
    },
    workflowEmail: {
      immediate: true,
      handler() {
        this.reloadData()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.channel-menu {
  width: 95%;
}

>>> .el-tabs__header {
  padding-left: 30px;
  padding-top: 22px;
  margin: 0 0 0;
  background-color: #ffffff;
}

>>> .el-tabs__nav-wrap {
  margin-top: -1px;
}

>>> .el-tabs__nav-wrap::after {
  background-color: #ffffff;
}

.preview {
  background-color: #f8fafc;
}

.full-size {
  display: flex;
  flex-direction: column;
  width: 96%;
  margin-left: 2%;
}

.device-selector {
  margin-bottom: 20px;
  padding-left: 30px;
  padding-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/PreviewContent.vue